export default "__VITE_ASSET__92897653__"